export default {
	"6e5998108827d7090342f60ce5ed12d1": "没有检测到支付结果",
	"df2c8aec0bfb103dfa35c521cd09c123": "若已支付请点击刷新进行结果查询",
	"9e515b60501b2753783c75ed0438b233": "刷新",
	"17889ebd5ded84c80621a617c129a1d3": "重新支付"
}
